import Progress from "./Progress";
import { ReactComponent as CompletedProgress } from "./progrss_with_trophy.svg";

export { Progress, CompletedProgress };
